import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ToasterModule } from 'angular2-toaster/angular2-toaster';

import { AccordionModule } from 'ngx-bootstrap/accordion';
import { AlertModule } from 'ngx-bootstrap/alert';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { RatingModule } from 'ngx-bootstrap/rating';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { DatepickerModule } from 'ngx-bootstrap/datepicker';

import { FlotDirective } from './directives/flot/flot.directive';
import { SparklineDirective } from './directives/sparkline/sparkline.directive';
import { EasypiechartDirective } from './directives/easypiechart/easypiechart.directive';
import { ColorsService } from './colors/colors.service';
import { CheckallDirective } from './directives/checkall/checkall.directive';
import { VectormapDirective } from './directives/vectormap/vectormap.directive';
import { NowDirective } from './directives/now/now.directive';
import { ScrollableDirective } from './directives/scrollable/scrollable.directive';
import { JqcloudDirective } from './directives/jqcloud/jqcloud.directive';
import {
    LoadingComponent,
    NoticesComponent,
    ErrorComponent,
    ProductDetailComponent,
    RequisitionProductsComponent,
    RequisitionAuthorisationTrailComponent
} from './components';
import { KeysPipe } from './pipes/keys.pipe';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { sanitizeHtmlPipe } from './pipes/sanitiser.pipe';
import {LoaderService,StorageService,DomainService,HttpService,AuthService,UserService,ProductsService,CommonService,CheckoutService,OrderService,GoogleAnalyticsService } from './services';
import { RedirectToGuard, DomainGuard, AuthGuard, LoggedinGuard, CompanyGuard } from './guards';

// https://angular.io/styleguide#!#04-10
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AccordionModule.forRoot(),
        AlertModule.forRoot(),
        ButtonsModule.forRoot(),
        CarouselModule.forRoot(),
        CollapseModule.forRoot(),
        DatepickerModule.forRoot(),
        BsDropdownModule.forRoot(),
        ModalModule.forRoot(),
        PaginationModule.forRoot(),
        ProgressbarModule.forRoot(),
        RatingModule.forRoot(),
        TabsModule.forRoot(),
        TimepickerModule.forRoot(),
        TooltipModule.forRoot(),
        TypeaheadModule.forRoot(),
        ToasterModule
    ],
    providers: [
        ColorsService,
        RedirectToGuard,
        DomainGuard,
        AuthGuard,
        LoggedinGuard,
        CompanyGuard
    ],
    declarations: [
        FlotDirective,
        SparklineDirective,
        EasypiechartDirective,
        CheckallDirective,
        VectormapDirective,
        NowDirective,
        ScrollableDirective,
        JqcloudDirective,
        LoadingComponent,
        NoticesComponent,
        ErrorComponent,
        ProductDetailComponent,
        RequisitionProductsComponent,
        RequisitionAuthorisationTrailComponent,
        KeysPipe,
        SafeUrlPipe,
        sanitizeHtmlPipe
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        AccordionModule,
        AlertModule,
        ButtonsModule,
        CarouselModule,
        CollapseModule,
        DatepickerModule,
        BsDropdownModule,
        ModalModule,
        PaginationModule,
        ProgressbarModule,
        RatingModule,
        TabsModule,
        TimepickerModule,
        TooltipModule,
        TypeaheadModule,
        ToasterModule,
        FlotDirective,
        SparklineDirective,
        EasypiechartDirective,
        CheckallDirective,
        VectormapDirective,
        NowDirective,
        ScrollableDirective,
        JqcloudDirective,
        LoadingComponent,
        NoticesComponent,
        ErrorComponent,
        ProductDetailComponent,
        RequisitionProductsComponent,
        RequisitionAuthorisationTrailComponent,
        KeysPipe,
        SafeUrlPipe,
        sanitizeHtmlPipe
    ]
})

export class SharedModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: SharedModule,
            providers: [
                LoaderService,
                StorageService,
                DomainService,
                HttpService,
                AuthService,
                UserService,
                ProductsService,
                CommonService,
                CheckoutService,
                OrderService,
                GoogleAnalyticsService
            ]
        };
    }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/shared/shared.module.ts